<template>
    <div class="account-data" v-loading="loading">
        <div class="account-data__content">
            <header>Гражданство</header>
            <WideAppendixData v-model="profile.appendix" />
            <div
                v-for="(_, index) in docs"
                class="account-data__item"
                :key="index"
            >
                <div class="delete-block">
                    <div
                        class="delete-block__btn"
                        @click="rmDoc(docs[index], index)"
                        data-voicetext="Удалить добавленный блок"
                    >
                        {{
                            isMobile
                                ? 'Удалить блок'
                                : 'Удалить добавленный блок'
                        }}<span>+</span>
                    </div>
                </div>
                <WideDoc
                  v-model="docs[index]"
                  :allDocs="docs"
                  :docTypes="docTypes"
                  @error="errorHandler(index, $event)"
                />
            </div>
            <div
                v-if="docs.length < maxDocs"
                class="add-block-btn"
                :class="{ 'add-block-btn--mt': docs.length }"
                @click="addDoc"
            >
                Добавить документ
            </div>
        </div>
        <FixedSaveBtn
            v-if="showFixedSaveBtn"
            @close="closeFixedBtn"
        >
            <ActionButton
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.fixedText"
                :disabled="hasErrors"
                class="save-block__btn--position save-block__btn"
            />
        </FixedSaveBtn>
        <div
            class="save-block"
        >
            <ActionButton
                ref="docsBtn"
                @b-action="saveData"
                :b-color="saveButton.color"
                b-t-color="white"
                :b-text="saveButton.text"
                :disabled="hasErrors"
                class="save-block__btn--position save-block__btn"
            />
        </div>
    </div>
</template>

<script>
import ActionButton from '../../../UI/inputs/ActionButton';
import FixedSaveBtn from '../FixedSaveBtn';
import WideDoc from './WideDoc';
import WideAppendixData from './WideAppendixData';
import { mapGetters, mapActions } from 'vuex';

const getters = [
    'getDocs',
    'isMobile',
    'userProfileInfo',
    'dictionaryByType',
];
const actions = [
    'loadDocs',
    'addDocs',
    'removeDoc',
    'saveDoc',
    'postProfileData',
    'loadDictionaryItems',
];

export default {
    name: 'WideDocsData',
    data: () => ({
        showFixedSaveBtn: false,
        observer: null,
        docs: [],
        errors: {},
        loading: false,
        saveButton: {
            fixedText: 'Сохранить изменения',
            text: 'Сохранить',
            color: '#4663AB',
            status: 'wait',
        },
        profile: {
            appendix: {
                citizenship: '',
            },
        },
    }),
    computed: {
        ...mapGetters(getters),
        docTypes() {
          return this.dictionaryByType('docs');
        },
        maxDocs() {
          return this.docTypes.length;
        },
        hasErrors() {
            return Object.values(this.errors).filter(Boolean).length > 0;
        },
    },
    components: {
        ActionButton,
        WideDoc,
        WideAppendixData,
        FixedSaveBtn,
    },
    methods: {
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        addDoc() {
            this.addDocs();
            this.docs = this.getDocs;
        },
        async rmDoc(doc, index) {
            await this.removeDoc({ doc: doc, index: index });
            this.docs = this.getDocs;
            this.errors[index] = false;
        },
        async saveProfileData() {
            const sendData = {
                ...this.profile.appendix,
            };
            await this.postProfileData(sendData);
        },
        async saveData() {
            if (this.saveButton.status !== 'wait') return;
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            try {
                const promises = [this.saveProfileData()];
                this.docs.forEach((doc, index) => {
                    promises.push(this.saveDoc({ doc: doc, index: index }));
                });
                await Promise.all(promises);
                this.saveButton.status = 'wait';
                this.saveButton.color = '#238C47';
                this.saveButton.text = 'Данные сохранены';
                this.saveButton.fixedText = 'Данные сохранены';
                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
        },
        errorHandler(index, data) {
            this.errors = {...this.errors, [index]: data};
        },
    },
    created() {
        const cb = key => {
            if (this.profile.appendix.hasOwnProperty(key)) {
                this.profile.appendix[key] = this.userProfileInfo[key];
            }
        };
        Object.keys(this.userProfileInfo).forEach(cb);
    },
    async mounted() {
        this.loading = true;
        this.loadDictionaryItems("docs");
        await this.loadDocs();
        this.docs = this.getDocs;
        this.loading = false;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach( (entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });
        this.$watch('profile', () => {
            this.observer.observe(this.$refs.docsBtn.$el);
        }, {deep: true});
        this.$watch('docs', () => {
            this.observer.observe(this.$refs.docsBtn.$el);
        }, {deep: true});
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';

.save-block {

    @include on-desktop {
        margin-top: rem(20);
    }
}
</style>
